import React from "react";
import { Tooltip, Tag } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { getTimezoneOffset } from "../utils/timezoneUtils";

/**
 * 时区信息显示组件
 * 显示时区名称和UTC偏移量
 * @param {string} timezone - 时区名称
 * @param {string} utcOffsetString - 后端提供的UTC偏移量字符串，如"+05:00"
 * @param {number} utcOffsetMinutes - 后端提供的UTC偏移分钟数，如300表示+5小时
 *
 */
const TimezoneInfo = ({ timezone, utcOffsetString, utcOffsetMinutes }) => {
    if (!timezone) return <span>-</span>;

    // 确定偏移量文本
    let finalOffsetDisplay;

    if (utcOffsetString) {
        // 使用后端提供的偏移量字符串 (它已经是简洁格式如 +8, -5:30, 或 Z)
        finalOffsetDisplay = utcOffsetString === "Z" ? "UTC+0" : `UTC${utcOffsetString}`;
    } else if (typeof utcOffsetMinutes === "number") {
        // 使用后端提供的偏移分钟数，格式化为简洁形式
        if (utcOffsetMinutes === 0) {
            finalOffsetDisplay = "UTC+0";
        } else {
            const hours = Math.floor(Math.abs(utcOffsetMinutes) / 60);
            const minutes = Math.abs(utcOffsetMinutes) % 60;
            const sign = utcOffsetMinutes >= 0 ? "+" : "-";
            const minuteStr = minutes > 0 ? `:${minutes.toString().padStart(2, "0")}` : "";
            finalOffsetDisplay = `UTC${sign}${hours}${minuteStr}`;
        }
    } else {
        // 前端计算偏移量（备用方案）
        const calculatedOffset = getTimezoneOffset(timezone); // getTimezoneOffset 应该返回如 "UTC+8"
        finalOffsetDisplay = calculatedOffset;
    }

    return (
        <Tooltip title={`${timezone} (${finalOffsetDisplay})`}>
            <Tag icon={<GlobalOutlined />} color="blue">
                {finalOffsetDisplay}
            </Tag>
        </Tooltip>
    );
};

export default TimezoneInfo;
